<template>
  <div class="user-avatar-dropdown">
    <span style="display:inline-block;margin-right: 10px;font-size: 16px;">
      {{ nickName||userName }}
    </span>
    <Dropdown @on-click="handleClick">
      <Badge :dot="!!messageUnreadCount">
        <Avatar :src="userAvatar" />
      </Badge>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <!-- <DropdownItem name="password">
          修改密码
        </DropdownItem> -->
        <a  v-for="(item,index) in applications" :href="item.applicationUrl + '?token='+ getToken()" target="_blank">
        <DropdownItem :key="index" :name="item.applicationName">
          {{ item.applicationName }}
        </DropdownItem>
        </a>

        <Divider style="margin: 5px 0 0;" />
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Modal v-model="showModal" title="修改密码">
      <Form @submit.native.prevent :model="form" ref="formRef">
        <FormItem label="旧密码" prop="originalPassword" :rules="[{required:true,message:'请输入密码'}]">
          <Input type="password" v-model="form.originalPassword"/>
        </FormItem>
        <FormItem label="新密码" prop="password" :rules="[{required:true,message:'请输入密码'}]">
          <Input type="password" v-model="form.password"/>
        </FormItem>
        <FormItem label="确认密码" prop="confirmPsd" :rules="[{required:true,message:'请输入密码'},{ validator: (rule, value, callback) => value!=form.password?callback('两次输入密码不一致'):callback()}]">
          <Input type="password" v-model="form.confirmPsd"/>
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="showModal=false">取消</Button>
        <Button @click="handleConfirm" type="primary">确定</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import { getToken } from '../../../../libs/util';
import './user.less'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'User',
  props: {
    userAvatar: {
      type: String,
      default: ''
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    }
  },
  data(){
    return {
      showModal:false,
      form: {},
      getToken
    }
  },
  computed: {
    ...mapState({
      applications: (state)=>state.user.applications,
      nickName: (state)=>state.user.nickName,
      userName: (state)=>state.user.userName,
    })
  },
  methods: {
    ...mapActions([
      'handleLogOut',
      'editPsd'
    ]),
    logout() {
      this.handleLogOut().then(() => {
        this.$router.push({
          name: 'login'
        })
      })
    },
    handleConfirm(){
      this.$refs.formRef.validate((r)=>{
        if(r){
          this.editPsd({
            password: this.form.password,
            originalPassword: this.form.originalPassword
          }).then(r=>{
            this.$Message.success('修改成功')
            this.logout()
          })
        }
      })
    },
    password() {
      this.form = {}
      this.showModal = true
    },
    handleClick(name) {
      switch (name) {
        case 'logout': this.logout()
          break
        case 'password': this.password()
          break
      }
    }
  }
}
</script>
